import { call, put, takeLatest } from "redux-saga/effects"

// action
import {
    ACTIVATE_DOCTOR,
    activateDoctorFail,
    activateDoctorSuccess
} from '../action/activateDoctorAction'

// api 
import activateDoctorApi from '../api/activateDoctorApi'

export function* activateDoctorSaga(action) {
    try {
        const response = yield call(() => activateDoctorApi(action.params))
        if (response.data.status === 1) {
            yield put(activateDoctorSuccess(response, action))
        } else {
            yield put(activateDoctorFail(response, action))
        }
    }
    catch (e) {
        yield put(activateDoctorFail(e.response, action))
    }

}

export default function* mySaga() {
    yield takeLatest(ACTIVATE_DOCTOR, activateDoctorSaga)
}